"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const daysBetween = (endDate, startDate) => date_fns_1.differenceInDays(endDate, startDate);
exports.default = daysBetween;
